<script>
import appConfig from "@/app.config";

export default {
  layout: "auth",
  page: {
    title: "Erro 500",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      title: "Error 500",
    };
  }
};
</script>

<template>
  <div class="my-5 pt-sm-5">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="text-center">
            <div>
              <div class="row justify-content-center">
                <div class="col-sm-4">
                  <div class="error-img">
                    <img
                      src="@/assets/images/500-error.png"
                      alt
                      class="img-fluid mx-auto d-block"
                    />
                  </div>
                </div>
              </div>
            </div>
            <h4 class="text-uppercase mt-4">Desculpe, alguma coisa deu errado com a sua requisição.</h4>
            <p class="text-muted">
              Por favor, entre em contato com a equipe de suporte para obter ajuda.
            </p>
            <div class="mt-5">
              <router-link to="/" class="btn btn-primary"
                >Voltar a tela inicial</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
